import { IApplicationState } from '../../types/redux';

export function getNewbuildingId(state: IApplicationState) {
  return state.newbuilding.id;
}
